import { normalizeChangelog } from '@/lib/changelog';

export const VERSION = import.meta.env.VITE_APP_VERSION || 'dev';
export const CHANGELOG_REF_PROJECT_ID = 3773;
// Ticket #3377
export const FEEDBACK_LOOP_TICKET_ID: string | null =
  'c124843e-2bd1-4daf-a055-af6b18c5b667';
export const CHANGELOG = normalizeChangelog(
  import.meta.env.VITE_APP_CHANGELOG as string | undefined,
);
